import { IconsProps } from '@/types/shared'
import React from 'react'

const ContractPendingIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.24 6.24999C13.07 5.07999 11.54 4.48999 10 4.48999V10.49L5.76 14.73C8.1 17.07 11.9 17.07 14.25 14.73C16.59 12.39 16.59 8.58999 14.24 6.24999ZM10 0.48999C4.48 0.48999 0 4.96999 0 10.49C0 16.01 4.48 20.49 10 20.49C15.52 20.49 20 16.01 20 10.49C20 4.96999 15.52 0.48999 10 0.48999ZM10 18.49C5.58 18.49 2 14.91 2 10.49C2 6.06999 5.58 2.48999 10 2.48999C14.42 2.48999 18 6.06999 18 10.49C18 14.91 14.42 18.49 10 18.49Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default ContractPendingIcons
